import SVGFrame from '../../assets/images'
import icons from '../../assets/icons'
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom'

function Footer() {
    const location = useLocation()
    return (
        <div className={`${location.pathname == '/coming' ? 'hidden':'block'} clear-both relative w-full  bg-[#040B11] px-[6.4rem] py-[4.9rem] xl:px-[25.5rem]`}>
            <div className='w-full  md:mb-[4.3rem] flex justify-between items-start'>
                <div className='sm:block hidden mr-[10rem]'>
                    {SVGFrame.logoFooter}
                </div>
                <div className='w-full flex justify-between flex-wrap'>
                    <ul className='flex flex-col sm:items-start items-start sm:mb-0 mb-[2.4rem] md:mr-[3.6rem] 2xl:mr-[13rem] mr-2'>
                        <li className='font-bakbak whitespace-nowrap text-[16px] mb-[2rem] text-white'>NAVIGATION</li>
                        <li className='font-bakbak whitespace-nowrap text-[14px] mb-[1.6rem] text-[#C2C3C5]'><Link to='/'>Home</Link></li>
                        <li className='font-bakbak whitespace-nowrap text-[14px] mb-[1.6rem] text-[#C2C3C5]'><a _target='_blank' href='https://www.youtube.com/watch?v=FwTQ0yoF0_g&list=PL_-VfJajZj0UXjlKfBwFX73usByw3Ph9Q&index=61'>Roadmap</a></li>
                        <li className='font-bakbak whitespace-nowrap text-[14px] mb-[1.6rem] text-[#C2C3C5]'><a href='/#'>Our Team</a></li>
                        <li className='font-bakbak whitespace-nowrap text-[14px] mb-[1.6rem] text-[#C2C3C5]'><a href='/#'>FAQs</a></li>
                    </ul>
                    <ul className='flex flex-col sm:items-start items-start sm:mb-0 mb-[2.4rem] md:mr-[3.6rem] 2xl:mr-[13rem] mr-2'>
                        <li className='font-bakbak whitespace-nowrap text-[16px] mb-[2rem] text-white'>COMPANY</li>
                        <li className='font-bakbak whitespace-nowrap text-[14px] mb-[1.6rem] text-[#C2C3C5]'><a _target='_blank' href=''>Terms Conditions</a></li>
                        <li className='font-bakbak whitespace-nowrap text-[14px] mb-[1.6rem] text-[#C2C3C5]'><a href='/#'>Privacy Policy</a></li>
                        <li className='font-bakbak whitespace-nowrap text-[14px] mb-[1.6rem] text-[#C2C3C5]'><a href='/#'>Whitepaper</a></li>
                        <li className='font-bakbak whitespace-nowrap text-[14px] mb-[1.6rem] text-[#C2C3C5]'><a href='/#'>Help Center</a></li>
                    </ul>
                    <div className='sm:mb-0 mb-[2.4rem] flex flex-col sm:items-start items-start'>
                        <p className=' font-bakbak text-[16px] mb-[2rem] text-white'>SUBSCRIBE</p>
                        <div className='bg-third rounded-full flex flex-nowrap'>
                            <input className='sm:min-w-[20.8rem] w-full outline-none border-none rounded-l-full pr-[1rem] pl-[2.4rem] bg-transparent marker:bg-transparent text-[#C2C3C5] text-[16px] font-poppin py-[1.55rem] ' type="email" name="email" placeholder='Enter your email' />
                            <button className='px-[3.55rem] py-[1.6rem] bg-primary duration-300 active:bg-opacity-50 rounded-full font-bakbak text-[16px]' type={'submit'}>SUBSCRIBE</button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='pt-[1.9rem] border-t border-t-[#434343] flex justify-between gap-x-[2rem] gap-y-[3rem] flex-wrap'>
                <p className='text-[14px] font-poppin text-[#C2C3C5] whitespace-nowrap'>Fannations 2022 - ALL rights reserved</p>
                <ul className='flex flex-nowrap gap-x-[4.2rem]'>
                    <li className=''>
                        <a _target='_blank' href='https://twitter.com/FanNationsWC'>
                            {icons.twitter}
                        </a>
                    </li>
                    <li className=''>
                        <a _target='_blank' href='https://www.facebook.com/FannationsNFT'>
                            {icons.fb}
                        </a>
                    </li>
                    <li className=''>
                        <a _target='_blank' href='https://t.me/FannationsGlobal'>
                            {icons.tele}
                        </a>
                    </li>
                    <li className=''>
                        <a _target='_blank' href='https://twitter.com/'>
                            {icons.discord}
                        </a>
                    </li>

                </ul>
            </div>
        </div>
    )
}

export default Footer

